import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { getI18n } from '../lib/i18n';
const NoResults = ({ query, synonyms }) => {
    const i18n = getI18n();
    if (query.trim().length < 3) {
        return (_jsx("div", { className: "eno-search-no-results", children: _jsx("p", { children: i18n.shortQueryHint }) }));
    }
    const getSuggestions = () => {
        const words = query.toLowerCase().split(/\s+/);
        const suggestions = new Set();
        words.forEach(word => {
            if (synonyms[word]) {
                synonyms[word].forEach(synonym => {
                    suggestions.add(synonym);
                });
            }
        });
        if (query.length > 3) {
            suggestions.add(query.slice(0, -1));
            suggestions.add(query + 's');
        }
        return Array.from(suggestions).slice(0, 5);
    };
    const suggestions = getSuggestions();
    const handleSuggestionClick = (suggestion) => {
        const event = new CustomEvent('eno-search:suggestion', { detail: suggestion });
        window.dispatchEvent(event);
    };
    const noResultsHeading = i18n.noResultsFor.replace('%s', query);
    return (_jsxs("div", { className: "eno-search-no-results", children: [_jsx("h3", { children: noResultsHeading }), _jsx("p", { children: i18n.noResultsTip }), suggestions.length > 0 && (_jsxs(_Fragment, { children: [_jsx("p", { children: i18n.suggestions }), _jsx("div", { className: "eno-search-suggestions", children: suggestions.map((suggestion, idx) => (_jsx("button", { className: "eno-search-suggestion", onClick: () => handleSuggestionClick(suggestion), type: "button", children: suggestion }, idx))) })] })), _jsxs("div", { style: { marginTop: '1.5rem', fontSize: '0.875rem', color: '#6b7280' }, children: [_jsx("p", { children: i18n.searchTips }), _jsxs("ul", { style: { textAlign: 'left', paddingLeft: '1.5rem', margin: '0.5rem 0' }, children: [_jsx("li", { children: i18n.tipBroader }), _jsx("li", { children: i18n.tipSku }), _jsx("li", { children: i18n.tipCategory }), _jsx("li", { children: i18n.tipFilters })] })] })] }));
};
export default NoResults;
